import { useEffect, useState } from "react";
import { api, BRANCH_KEY } from "@/lib/api";
import { setMultiBranch } from "@/lib/branchInfo";
import { useAuth } from "@/context/AuthContext";

// Which branch is on screen. Shown only when the company has more than one; with one branch everything files under it.
export function BranchSwitcher() {
  const { user } = useAuth() || {};
  const [branches, setBranches] = useState([]);
  const [chosen, setChosen] = useState(() => localStorage.getItem(BRANCH_KEY) || "");
  // someone tied to a branch works only in it: the box shows it and cannot be changed (the server refuses any other branch too)
  const tied = user && user.role !== "ORG_ADMIN" && user.branch_id ? user.branch_id : "";

  useEffect(() => {
    if (tied && localStorage.getItem(BRANCH_KEY) !== tied) {
      localStorage.setItem(BRANCH_KEY, tied);
      window.location.reload();                                  // load every page again for their branch
    }
  }, [tied]);

  useEffect(() => {
    api.get("/masters/branches").then(({ data }) => {
      const active = data.filter((b) => b.is_active);
      setBranches(active);
      setMultiBranch(active.length > 1);
      if (chosen && !active.some((b) => b.id === chosen)) {   // the saved branch was deleted or switched off
        localStorage.removeItem(BRANCH_KEY);
        setChosen("");
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (branches.length < 2) return null;
  if (tied) {
    return (
      <div className="flex items-center gap-2 border-b bg-card px-4 py-1.5 text-sm sm:px-6" data-testid="branch-switcher">
        <span className="font-medium text-muted-foreground">Branch</span>
        <span className="rounded-md border bg-muted/40 px-2 py-1" data-testid="branch-fixed">{user.branch_name || branches.find((b) => b.id === tied)?.name || "Your branch"}</span>
        <span className="text-xs text-muted-foreground">You work in this branch.</span>
      </div>
    );
  }

  const change = (event) => {
    const id = event.target.value;
    if (id) localStorage.setItem(BRANCH_KEY, id);
    else localStorage.removeItem(BRANCH_KEY);
    window.location.reload();   // every page is loaded again for the new branch
  };

  return (
    <div className="flex items-center gap-2 border-b bg-card px-4 py-1.5 text-sm sm:px-6" data-testid="branch-switcher">
      <label htmlFor="branch-switcher-select" className="font-medium text-muted-foreground">Branch</label>
      <select
        id="branch-switcher-select"
        data-testid="branch-switcher-select"
        value={chosen}
        onChange={change}
        className="h-8 rounded-md border bg-background px-2"
      >
        <option value="">All branches</option>
        {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </select>
      {!chosen && <span className="text-xs text-muted-foreground">Pick one branch before creating new records.</span>}
    </div>
  );
}
